import { ILesson } from "@buildwitt/shapeshift-types";
import { ICourseModule } from "@buildwitt/shapeshift-types/ICourse";

export const isNotOverdue = (dueDate: Date): boolean => {
	const due = dueDate ? new Date(dueDate) : null;
	if (!due) return true;
	const today = new Date();
	today.setHours(0, 0, 0, 0);
	due.setHours(0, 0, 0, 0);
	return due >= today;
};

export const isOverdue = (dueDate: Date): boolean => {
	return !isNotOverdue(dueDate);
};

export const getVideoThumbnail = (module: ICourseModule | null): string | undefined => {
	if(module.moduleThumbnailOverride)
		return module.moduleThumbnailOverride.formats?.small?.url ?? module.moduleThumbnailOverride.url;

	if (module?.type === "lesson") {
		const lesson = module as ILesson;

		if (lesson.videoThumbnailUrl) {
			return lesson.videoThumbnailUrl;
		}

		return "/holding_image.jpg"
	}

	return undefined;
};